import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DropzoneDirective } from 'ngx-dropzone-wrapper';
import { DEFAULT_ASPECT_RATIOS, IAspectRatioInfo } from '../../../constants/common.constants';
import { ImageCropperExtraService } from '../../../../image-cropper/image-cropper-extra.service';

@Component({
  standalone: false,
  selector: 'ui-choose-motive-section',
  templateUrl: './ui-choose-motive-section.component.html',
  styleUrls: ['./ui-choose-motive-section.component.scss']
})
export class UiChooseMotiveSectionComponent {
  @Input() public imgUrl: string;
  @Input() public maxImageSize?: number;

  @Output() public onSubmit = new EventEmitter<string>();
  @Output() public onClose = new EventEmitter<void>();

  public resultImgUrl: string;
  public file: File;

  public aspectRatios: IAspectRatioInfo[] = DEFAULT_ASPECT_RATIOS;
  public selectedAspectRatio: IAspectRatioInfo = null;

  @ViewChild(DropzoneDirective, { static: false }) myDropzone?: DropzoneDirective;

  constructor(private _imageService: ImageCropperExtraService) {
  }

  uploadImage() {
    this.onSubmit.emit(this.selectedAspectRatio
      ? this.resultImgUrl
      : this.imgUrl);
  }
}
